export default {
  name: 'Arate',
  props: {
    value: null,
  },
  methods: {
    change(a) {
      this.$emit('change', a);
    }
  },
  render() {
    const { ...attrs } = this.$attrs;
    return (
      <el-rate v-model={value} show-text on-change={this.change} {...{ attrs }} />
    );
  }
}